export const testimonials = [
  {
    id: 1,
    name: '小雅',
    age: 28,
    city: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20smiling%20warmly%20portrait%20soft%20natural%20light%20cream%20background%20clean%20editorial%20style%20simple%20casual%20outfit&width=200&height=200&seq=testimonial-01&orientation=squarish',
    content: '在久久爱上遇到了现在的另一半，匹配系统真的太准了！我们的价值观和生活方式高度一致，相处起来特别舒服。现在已经在一起一年多了，每天都很幸福。',
    rating: 5,
    date: '2026-06-15',
  },
  {
    id: 2,
    name: '大伟',
    age: 32,
    city: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20his%20thirties%20warm%20genuine%20smile%20professional%20portrait%20clean%20cream%20background%20editorial%20style%20simple%20casual%20shirt&width=200&height=200&seq=testimonial-02&orientation=squarish',
    content: '作为一个性格内向的程序员，我一直不太擅长社交和谈恋爱。久久爱的情感指导服务帮我建立了很多自信，让我学会了如何表达和沟通。',
    rating: 5,
    date: '2026-05-20',
  },
  {
    id: 3,
    name: '思琪',
    age: 26,
    city: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20young%20woman%20gentle%20warm%20expression%20portrait%20soft%20cream%20background%20editorial%20style%20simple%20white%20shirt%20natural%20makeup&width=200&height=200&seq=testimonial-03&orientation=squarish',
    content: '和男朋友闹矛盾的时候，久久爱的修复指导课程真的帮了大忙。按照老师教的方法一步步沟通，我们不但和好了，感情比以前更好了！',
    rating: 5,
    date: '2026-07-01',
  },
  {
    id: 4,
    name: '建国',
    age: 35,
    city: '深圳',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20warm%20kind%20smile%20professional%20portrait%20clean%20cream%20background%20editorial%20style%20simple%20polo%20shirt%20natural%20light&width=200&height=200&seq=testimonial-04&orientation=squarish',
    content: '结婚七年，感觉感情越来越淡。老婆推荐久久爱后，我们一起参加了伴侣陪伴课程，重新找回了恋爱时心动的感觉。感谢久久爱让我们的婚姻重获新生。',
    rating: 4,
    date: '2026-06-28',
  },
  {
    id: 5,
    name: '美玲',
    age: 30,
    city: '成都',
    avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20woman%20with%20radiant%20smile%20portrait%20soft%20cream%20background%20editorial%20style%20warm%20lighting%20simple%20elegant%20attire&width=200&height=200&seq=testimonial-05&orientation=squarish',
    content: '失恋后一度很难走出来，久久爱的情感陪伴师给了我很多支持和引导。现在已经完全走出来了，还通过平台认识了新的朋友。感谢这段陪伴。',
    rating: 5,
    date: '2026-07-12',
  },
  {
    id: 6,
    name: '浩然',
    age: 29,
    city: '杭州',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20confident%20friendly%20smile%20portrait%20clean%20cream%20background%20editorial%20style%20simple%20casual%20outfit%20warm%20lighting&width=200&height=200&seq=testimonial-06&orientation=squarish',
    content: '通过久久爱的伴侣匹配找到了现在的未婚妻。我们匹配度高达95%！相处后发现确实各方面都很合拍。已经订婚了，明年就结婚。感谢久久爱！',
    rating: 5,
    date: '2026-07-25',
  },
];